import { useContext, useEffect, useState } from "react";
import { I18N } from "oc-I18N";
import classnames from "classnames";
import { CopySvg } from "../../inlinesvgs/CopySvg";
import { WarenkorbButton } from "../WarenkorbButton";
import { SavingContext } from "../../hooks/UseSaving";
import { CheckSVG } from "../../inlinesvgs/CheckSvg";
import { EditInZaunButton } from "../../torkonfigurator/MHelper";

type copyState = "unclicked" | "clickedWithin" | "clickedOutside";

export function FertigDialog({ onClose }: { onClose: () => void }) {
  const { active: saving, state: savingState } = useContext(SavingContext);
  const [shown, setShown] = useState(false);
  useEffect(() => {
    if (!shown && savingState == "saving") {
      setShown(true);
    }
  }, [savingState]);

  const wrappedOnClose = () => {
    setShown(false);
    onClose();
  };

  const url = APP.settings.configuratorUrl.ensureRight("/") + "?Code=" + APP.configuration.Code;
  const pdfUrl = APP.wkfgBackendApi.getPdfUrl(APP.configuration.Code, false);

  return (
    shown && (
      <div className={"fullsize fertig-dialog-wrapper"} role="presentation">
        <div
          className={classnames(
            "fertig-dialog grid-fullscreen bordered shadow dialog fade z-index-on-top"
          )}
          role="dialog"
          aria-modal="true"
          aria-labelledby="fertig-dialog-title"
        >
          <button
            type="button"
            className="icon-close"
            onClick={wrappedOnClose}
            aria-label={I18N("aria::Fertig-Dialog schließen")}
          ></button>
          <h2 id="fertig-dialog-title" className="sr-only">
            {I18N("Konfiguration gespeichert")}
          </h2>
          <div className="question text-center" role="status" aria-live="polite" aria-atomic="true">
            {saving ? (
              <>
                <p className="fade">{I18N("Ihr Zaun wird gerade gespeichert.")}</p>
                <p className="fade">
                  {I18N("Es werden Bilder generiert. Dies kann einen Moment dauern.")}
                </p>
                <br />
                <div className="loading"></div>
              </>
            ) : (
              <>
                <p className="fade">{I18N("Ihr Zaun ist fertig und gespeichert.")}</p>
                <p className="fade">
                  {I18N("Sie können ihren Zaun unter folgendem Link jederzeit wieder aufrufen:")}
                </p>
                <br />
                <UrlField url={url} />
              </>
            )}
          </div>

          <div className="redirect-button">
            {APP.isTorkonfigurator && !saving && <EditInZaunButton />}
          </div>

          <div className="button-container">
            <div className="button-container-column flex-gap-1">
              {APP.arrangement.montageanleitungen.map(
                ({ MontageanleitungPdf, MontagePdfKuerzel }) => (
                  <a
                    key={MontageanleitungPdf}
                    href={MontageanleitungPdf}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="outlined-button fertig-button font-size-1"
                    aria-label={
                      I18N("aria::Montageanleitung herunterladen") +
                      ": " +
                      (MontagePdfKuerzel ?? "PDF")
                    }
                  >
                    <i className="icon icon-file-pdf-solid" aria-hidden="true"></i>
                    {MontagePdfKuerzel ?? I18N("PDF Montageanleitung herunterladen")}
                  </a>
                )
              )}
            </div>
            <div className="button-container-column flex-gap-1">
              {!saving && (
                <>
                  <a
                    href={pdfUrl}
                    target="_blank"
                    className="primary-button fertig-button font-size-1"
                  >
                    <i className="icon icon-file-pdf-solid"></i>
                    {I18N("PDF herunterladen")}
                  </a>
                  <WarenkorbButton />
                </>
              )}
            </div>
          </div>
        </div>
      </div>
    )
  );
}

export function UrlField({ url }: { url: string }) {
  const resetCopy = () => {
    console.log("reset");
    setClickedCopy("unclicked");
  };
  const [clickedCopy, setClickedCopy] = useState<copyState>("unclicked");
  return (
    <div className="urlfield align-center bordered">
      <a href={url}>{url}</a>
      &nbsp;
      <span
        className={classnames(
          "copy-button svg-button",
          clickedCopy === "unclicked" ? "active" : ""
        )}
        title={
          clickedCopy === "unclicked" ? I18N("in die Zwischenablage kopieren") : I18N("kopiert")
        }
        onClick={async () => {
          await navigator.clipboard.writeText(url);
          setClickedCopy("clickedWithin");
          console.log("set");
          setTimeout(() => {
            console.log("timeout");
            resetCopy();
          }, 8000);
        }}
        onMouseLeave={() => {
          if (clickedCopy === "clickedWithin") {
            setClickedCopy("clickedOutside");
          }
        }}
        onMouseEnter={() => {
          if (clickedCopy == "clickedOutside") {
            resetCopy();
          }
        }}
      >
        {clickedCopy === "unclicked" ? <CopySvg /> : <CheckSVG />}
      </span>
    </div>
  );
}
